/* eslint-disable no-unused-vars */
import _mob from '@/js/mob';
import _main from '@/js/main';
import bizMOB from '@/js/bizMOB-xross3';
//import { fileMobileApi } from '@/api/index';

var _file = {
  config: {},
  list: [],

  /**
   * 파일 목록 조회
   *
   * @param options 파일 옵션
   */
  search: function (options) {
    options.searchType = options.searchType || 'file';
    var fileList = [];
    var url;
    var data;
    // 일반 파일 목록 조회
    if (options.searchType == 'file') {
      //url = 'listFile';
      url = process.env.VUE_APP_API_URL + 'api/file/listFile';
      data = {
        enterCd: options.enterCd,
        type: options.type,
        fileSeq: options.fileSeq,
      };
    }

    //fileList = fileMobileApi.post(url, data);
    // 조회
    _mob.ajax(
      url,
      data,
      function (resData) {
        fileList = resData.data;
      },
      { async: false },
    );

    return fileList;
  },

  delete: function (enterCd, fileSeq, seqNo) {
    var data = {
      enterCd: enterCd,
      fileSeq: fileSeq,
      seqNo: seqNo,
    };

    // 삭제
    _mob.ajax(
      process.env.VUE_APP_API_URL + 'api/file/deleteFile',
      data,
      function (resData) {
        alert(resData.data.message);
      },
      { async: false },
    );
  },

  /**
   * 파일 보기
   */
  fileView: function (fileData) {
    if (fileData == undefined) {
      return;
    }

    //var viewerUrl ='http://172.16.67.191:8004' + fileData.filePath + '/' + fileData.sFileNm;

    //fileData.filePath = '/webapps/biz_file/temp/2024/03/28';
    //fileData.sFileNm = 'DB링크명 변경(HR).xlsx';

    // console.log('fileData : ' + JSON.stringify(fileData));

    var viewerUrl =
      //'https://dg1.bgf.co.kr/DG_viewer/viewer/document/docviewer.do' +
      //'http://121.140.152.221:8081/DG_viewer/viewer/document/docviewer.do' +
      'https://dg2.bgf.co.kr/DG_viewer/viewer/document/docviewer.do' +
      '?filepath=' +
      encodeURIComponent(
        process.env.VUE_APP_API_URL +
          'api/file/mobDownload?filePath=/data/hrfile/' + fileData.enterCd +
          //'http://172.16.67.191:8004/mobile/api/file/mobDownload?filePath=/data/hrfile/10' +
          fileData.filePath +
          '/' +
          '&fileName=' +
          fileData.sFileNm,
      ) + // 파일다운로드 경로
      '&filename=' +
      encodeURIComponent(fileData.rFileNm) + //파일명
      '&fileext=' +
      fileData.rFileNm.split('.').pop(); //확장자

    window.bizMOB.openInternalBrowser(viewerUrl, '파일보기');
  },

  /**
   * 임시 파일 업로드
   *
   * @param fileList 업로드할 파일 목록
   * @return 다운로드 url
   */
  mobUpload: async function (fileList, seq, isGen, isEdms, enterCd, fileSeq) {
    seq = seq || '';
    isGen = isGen == undefined ? false : isGen;
    isEdms = isEdms == undefined ? false : isEdms;

    //var addFileList = fileList.filter(
    //  data => data['_status'] == 'A' && isEdms == false,
    //);
    var addFileList = fileList;
    // 추가할 파일 목록
    var edmsFileList = []; // EDMS에서 선택한 파일 목록
    fileList
      .filter(data => data['_status'] == 'A' && isEdms == true)
      .forEach(data => {
        edmsFileList.push({
          seq: seq,
          type: '99',
          orgFileNm: data.name,
          savePath: data.path,
          _status: 'A',
        });
      });

    if (addFileList.length + edmsFileList.length == 0) {
      return seq;
    }

    //alert('addFileList = ' + JSON.stringify(addFileList, '', 2));

    // iBGF 앱에서 업로드할 경우
    if (isEdms == false) {
      var uploadFileList = [];

      addFileList.forEach((data, i) =>
        uploadFileList.push({
          _sSourcePath: data.path,
          _sFileName: 'REQ_' + new Date().getTime() + i,
        }),
      );

      // alert('uploadFileList = ' + JSON.stringify(uploadFileList, '', 2));
      var mobileFile = {};
      var completeUpload = false;
      window.bizMOB.File.upload({
        _aFileList: uploadFileList,
        _fCallback: function (res) {
          // alert('업로드 결과11111 = ' + JSON.stringify(res, '', 2));
          mobileFile = res;
          completeUpload = true;
        },
      });

      // 업로드 완료 체크
      var checkCompleteUpload = async function () {
        return await new Promise(function (resolve) {
          var interval = setInterval(function () {
            if (completeUpload == true) {
              resolve(mobileFile);
              clearInterval(interval);
            }
          }, 100);
        });
      };

      var data = await checkCompleteUpload();
      //alert('업로드 이후 = ' + JSON.stringify(data, '', 2));
      if (data.result == true) {
        var mobAddFileList = [];
        data.list.forEach(mf => {
          mobAddFileList.push({
            seq: seq,
            mobUid: mf.uid,
            orgFileNm: mf.file_name,
          });
        });

        //alert('mobAddFileList = ' + JSON.stringify(mobAddFileList, '', 2));

        var uploadData = {
          addFileList: mobAddFileList,
          seq: seq,
          isGen: isGen,
          enterCd: enterCd,
          fileSeq: fileSeq,
        };

        _mob.ajax(
          process.env.VUE_APP_API_URL + 'api/file/mobUpload',
          JSON.stringify(uploadData),
          function (resData) {
            fileSeq = resData;
            //alert('fileSeq _mob.ajax' + fileSeq);
            fileList.forEach(data1 => {
              resData.forEach(data2 => {
                if (
                  data1['_status'] == 'A' &&
                  data1['name'] == data2['orgFileNm']
                ) {
                  data1.seq = data2.seq;
                  data1.sortOrd = data2.sortOrd;

                  if (!seq) {
                    seq = data1.seq;
                  }
                }
              });
            });
          },
          { dataType: 'json', contentType: 'application/json', async: false },
        );
      } else {
        _mob.alert('파일 업로드 중 에러가 발생했습니다.');
      }
    } else {
      // 파일 업로드
      if (_mob.isEmpty(addFileList) == false) {
        // FormData
        var formData = new FormData();

        // 추가 파일 목록
        addFileList.forEach(data => {
          formData.append('addFileList', data);
        });

        // 업로드 파일이 있는 경우 파일 업로드
        if (formData.entries().next().done == false) {
          // seq 세팅
          formData.append('seq', seq);

          // 무조건 seq 채번할지 여부
          formData.append('isGen', isGen);

          // 업로드
          _mob.ajax(
            '/file/tempUpload',
            formData,
            function (resData) {
              fileList.forEach(data1 => {
                resData.forEach(data2 => {
                  if (
                    data1['_status'] == 'A' &&
                    data1['name'] == data2['orgFileNm']
                  ) {
                    data1.seq = data2.seq;
                    data1.sortOrd = data2.sortOrd;

                    if (!seq) {
                      seq = data1.seq;
                    }
                  }
                });
              });
            },
            { processData: false, contentType: false, async: false },
          );
        }
      }
    }

    return fileSeq;
  },

  /**
   * 결재 문서 보기
   * @param apprId 결재ID
   * @param fileName 파일명
   */
  openApprDocViewer: function (apprId, fileName) {
    var filePath = _file.config.apprDocUrl + '?appId=' + apprId;
    //alert(filePath);
    //alert(fileName);
    _file.openDocViewer(filePath, fileName, 'html');
  },

  /**
   * 문서변환 팝업 open
   *
   * @param filePath 보려고 하는 문서의 다운로드 url
   * @param fileName 파일명
   * @param ext 파일 확장자("jpeg", "html", "xlsx".... 등)
   */
  openDocViewer: function (filePath, fileName, ext) {
    var viewerUrl =
      _file.config.dgViewerUrl +
      '?filepath=' +
      encodeURIComponent(filePath) +
      '&filename=' +
      encodeURIComponent(fileName) +
      '&fileext=' +
      ext;
    //                      + "&userId=" + (userId || "")

    bizMOB.openInternalBrowser(viewerUrl, '파일보기');
  },

  mobileFile: [],
  completeUpload: [],
};

export default _file;
